export const URLS = Object.freeze({
  SAMPLES_DETAILS_CLOUD_SECTION: (sha1: string, section: string) =>
    `/${sha1}/${section}/`,
  SAMPLE_DETAILS_CLOUD_DYNAMIC: (sha1: string, section: string) =>
    `/${sha1}/dynamic/${section}/`
});

export const HASH_REGEX = /^[0-9a-fA-F]+$/;
